import React, { FunctionComponent, SyntheticEvent, useContext, useState } from 'react'
import ExcelJS from 'exceljs';
import { useTranslation } from 'react-i18next';
import { Moment } from 'moment';

// MUI
import Box from "@mui/material/Box";
import { DialogActions, Toolbar } from '@mui/material';

// MUI Icons
import FileDownloadIcon from "@mui/icons-material/FileDownloadOutlined";

// Custom
import useFormController from '@/components/useFormController';
import DialogHeader from '@/ui/Dialog/DialogHeader';
import DynamicDialog from '@/ui/Dialog/DynamicDialog';
import DialogToolbarButtonClose from '@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose';
import { FormAvatar } from '@/ui/Form';
import ToolbarFillContent from '@/ui/Toolbar/ToolbarFillContent';
import DialogContext from '@/ui/DialogContext/DialogContext';
import DialogBody from '@/ui/Dialog/DialogBody';
import { GridContainer } from '@/ui/Grid';
import FormContent from '@/components/FormContent';
import DialogActionButtonClose from '@/ui/Dialog/ActionButtons/DialogActionButtonClose';
import DialogActionButtonDownload from '@/ui/Dialog/ActionButtons/DialogActionButtonDownload';
import DialogToolbarHeading from '@/ui/Dialog/DialogToolbarHeading';
import { sifrarnici } from '@/lib/sifrarnici';

// Types
import { FormControllerProps } from '@/@types/components/formController';
import { IDialogProps } from '@/@types/ui/DialogContext'
import { DCRecord } from '@/@types/lib/dataController';


const CreateExcelDialog: FunctionComponent<IDialogProps> = (props) => {

  const { record, validation, fields, onFieldChange } =
    useFormController(props as FormControllerProps);

  const dialogContext = useContext(DialogContext);
  const { t } = useTranslation();
  const mode = "update";

  const handleClose = (evt: SyntheticEvent) => {
    dialogContext.hideDialog();
  };

  // TODO not enough time to test why is it not working
  // const fillRow = (counter: number, element: any, sheet: any) => {
  //   sheet.getCell("B"+counter.toString()).value = element.organizator_udruga_naziv as string;
  //   sheet.getCell("C"+counter.toString()).value = element.odrediste as string;
  //   sheet.getCell("D"+counter.toString()).value = (element.prvi_dan as Moment).local().format("DD.MM.YYYY");
  //   sheet.getCell("E"+counter.toString()).value = element.trajanje_dani as number;
  //   sheet.getCell("F"+counter.toString()).value = element.broj_sudionika as number;
  //   if (element.uloga === sifrarnici.vodic_sudionik_uloga.vodic) {
  //     sheet.getCell("G"+counter.toString()).value = "vodič";
  //   } else {
  //     sheet.getCell("G"+counter.toString()).value = "sudionik";
  //   }
  // }


  const handleDownload = async () => {
    try {
      const response = await fetch("/templates/HPS_Vodicki_obrazac.xlsx");
      const blob = await response.blob();
      const arrayBuffer = await blob.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);


      const sheet = workbook.getWorksheet(1);
      if (sheet) {
        // console.log(record.records);

        sheet.getCell("C8").value = record.first_name as string + " " + record.last_name as string;
        sheet.getCell("C10").value = record.oib as string;
        sheet.getCell("E10").value = record.mobitel as string;
        sheet.getCell("C12").value = record.email as string;
        sheet.getCell("C14").value = record.adresa as string ?? "";
        sheet.getCell("C16").value = record.hps_plan_udruga_naziv as string;
        sheet.getCell("C18").value = record.hps_spv_naziv as string;
        sheet.getCell("C20").value = record.hps_broj_vodicke_znacke as string ?? "";
        sheet.getCell("C24").value = record.pocetak ? (record.pocetak as Moment).local().format("DD.MM.YYYY") : "";
        sheet.getCell("E24").value = record.kraj ? (record.kraj as Moment).local().format("DD.MM.YYYY") : "";
        sheet.getCell("C26").value = record.edukacija as string;

        let counterA = 0;
        let sumSudioniciA = 0;
        let sumTrajanjeA = 0;

        let counterB = 0;
        let sumSudioniciB = 0;
        let sumTrajanjeB = 0;

        let counterC = 0;
        let sumSudioniciC = 0;
        let sumTrajanjeC = 0;

        let counterD = 0;
        let sumSudioniciD = 0;
        let sumTrajanjeD = 0;

        (record.records as DCRecord[]).forEach((element) => {
          // console.log(element)
          if (element.max_standard_id === 10 && counterA < 20) {
            sheet.getCell("B" + (30 + counterA).toString()).value = element.organizator_udruga_naziv as string;
            sheet.getCell("C" + (30 + counterA).toString()).value = element.odrediste as string;
            sheet.getCell("D" + (30 + counterA).toString()).value = (element.prvi_dan as Moment).local().format("DD.MM.YYYY");
            sheet.getCell("E" + (30 + counterA).toString()).value = element.trajanje_dani as number;
            sheet.getCell("F" + (30 + counterA).toString()).value = element.broj_sudionika as number;
            if (element.uloga === sifrarnici.vodic_sudionik_uloga.vodic) {
              sheet.getCell("G" + (30 + counterA).toString()).value = "vodič";
            } else {
              sheet.getCell("G" + (30 + counterA).toString()).value = "sudionik";
            }

            sumSudioniciA += element.broj_sudionika as number;
            sumTrajanjeA += element.trajanje_dani as number;
            counterA += 1;
          } else if (element.max_standard_id === 20 && counterB < 10) {
            sheet.getCell("B" + (55 + counterB).toString()).value = element.organizator_udruga_naziv as string;
            sheet.getCell("C" + (55 + counterB).toString()).value = element.odrediste as string;
            sheet.getCell("D" + (55 + counterB).toString()).value = (element.prvi_dan as Moment).local().format("DD.MM.YYYY");
            sheet.getCell("E" + (55 + counterB).toString()).value = element.trajanje_dani as number;
            sheet.getCell("F" + (55 + counterB).toString()).value = element.broj_sudionika as number;
            if (element.uloga === sifrarnici.vodic_sudionik_uloga.vodic) {
              sheet.getCell("G" + (55 + counterB).toString()).value = "vodič";
            } else {
              sheet.getCell("G" + (55 + counterB).toString()).value = "sudionik";
            }

            sumSudioniciB += element.broj_sudionika as number;
            sumTrajanjeB += element.trajanje_dani as number;
            counterB += 1;
          } else if (element.max_standard_id === 30 && counterC < 10) {
            sheet.getCell("B" + (69 + counterC).toString()).value = element.organizator_udruga_naziv as string;
            sheet.getCell("C" + (69 + counterC).toString()).value = element.odrediste as string;
            sheet.getCell("D" + (69 + counterC).toString()).value = (element.prvi_dan as Moment).local().format("DD.MM.YYYY");
            sheet.getCell("E" + (69 + counterC).toString()).value = element.trajanje_dani as string;
            sheet.getCell("F" + (69 + counterC).toString()).value = element.broj_sudionika as string;
            if (element.uloga === sifrarnici.vodic_sudionik_uloga.vodic) {
              sheet.getCell("G" + (69 + counterC).toString()).value = "vodič";
            } else {
              sheet.getCell("G" + (69 + counterC).toString()).value = "sudionik";
            }

            sumSudioniciC += element.broj_sudionika as number;
            sumTrajanjeC += element.trajanje_dani as number;
            counterC += 1;
          } else if (element.max_standard_id === 40 && counterD < 10) {
            sheet.getCell("B" + (83 + counterD).toString()).value = element.organizator_udruga_naziv as string;
            sheet.getCell("C" + (83 + counterD).toString()).value = element.odrediste as string;
            sheet.getCell("D" + (83 + counterD).toString()).value = (element.prvi_dan as Moment).local().format("DD.MM.YYYY");
            sheet.getCell("E" + (83 + counterD).toString()).value = element.trajanje_dani as string;
            sheet.getCell("F" + (83 + counterD).toString()).value = element.broj_sudionika as string;
            if (element.uloga === sifrarnici.vodic_sudionik_uloga.vodic) {
              sheet.getCell("G" + (83 + counterD).toString()).value = "vodič";
            } else {
              sheet.getCell("G" + (83 + counterD).toString()).value = "sudionik";
            }

            sumSudioniciD += element.broj_sudionika as number;
            sumTrajanjeD += element.trajanje_dani as number;
            counterD += 1;
          }
        })

        sheet.getCell("E50").value = {
          formula: "SUM(E30:E49)",
          result: sumTrajanjeA,
        };
        sheet.getCell("F50").value = {
          formula: "SUM(F30:F49)",
          result: sumSudioniciA,
        };

        sheet.getCell("E65").value = {
          formula: "SUM(E55:E64)",
          result: sumTrajanjeB,
        };
        sheet.getCell("F65").value = {
          formula: "SUM(F55:F64)",
          result: sumSudioniciB,
        };

        sheet.getCell("E79").value = {
          formula: "SUM(E69:E78)",
          result: sumTrajanjeC,
        };
        sheet.getCell("F79").value = {
          formula: "SUM(F69:F78)",
          result: sumSudioniciC,
        };

        sheet.getCell("E93").value = {
          formula: "SUM(E83:E92)",
          result: sumTrajanjeD,
        };
        sheet.getCell("F93").value = {
          formula: "SUM(F83:F92)",
          result: sumSudioniciD,
        };
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const fileBlob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });


      const link = document.createElement("a");
      link.href = URL.createObjectURL(fileBlob);
      link.download = "HPS_Vodicki_obrazac.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      dialogContext.hideDialog();
    } catch (error) {
      console.error("Error modifying the Excel file:", error);
    }
  }

  return (
    <DynamicDialog open maxWidth="md" fixedHeight onClose={handleClose}>
      <DialogHeader >
        <Toolbar variant="dense" disableGutters>
          <FormAvatar ariaLabel="poi" icon={<FileDownloadIcon />} />
          <DialogToolbarHeading>{t('titles.vodicki_obrazac')}</DialogToolbarHeading>
          <ToolbarFillContent />
          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogHeader>
      <DialogBody>
        <Box mt={2}>
          <GridContainer>
            <FormContent
              title={t("titles.osobni_podaci")}
              fieldNames={['first_name', 'last_name', 'oib', 'mobitel', 'email', 'adresa']}
              record={record}
              mode={mode}
              fields={fields}
              onFieldChange={onFieldChange}
            />
            <FormContent
              title={t("titles.hps_podaci")}
              fieldNames={['hps_plan_udruga_naziv', 'hps_spv_naziv', 'hps_broj_vodicke_znacke']}
              record={record}
              mode={mode}
              fields={fields}
              onFieldChange={onFieldChange}
            />
            <FormContent
              title={t("titles.opci_podaci")}
              fieldNames={['pocetak', 'kraj', 'edukacija']}
              record={record}
              mode={mode}
              fields={fields}
              onFieldChange={onFieldChange}
            />
          </GridContainer>
        </Box>
      </DialogBody>
      <DialogActions>
        <DialogActionButtonClose variant="outlined" onClick={handleClose} />
        <DialogActionButtonDownload variant="contained" onClick={handleDownload} />
      </DialogActions>
    </DynamicDialog>
  );
}

export default CreateExcelDialog
